import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {TypedValueSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {BooleanTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';

function getFlattenedStringValues(typedValue: TypedValue): Array<string> {
  if (typedValue.type === BaseTypedValueType.ARRAY) {
    return typedValue.rawValue.map((value) => getFlattenedStringValues(value)).flat();
  } else {
    return [formatTypedValue(typedValue)];
  }
}

export default {
  name: 'TEXTJOIN',
  category: FunctionCategory.TEXT,
  shortDescription: 'Combines the text from multiple strings and/or arrays.',
  description:
    'Combines the text from multiple strings and/or arrays, with a specifiable delimiter separating the different texts.',
  params: [
    {
      name: 'delimiter',
      type: ArgType.any,
      description:
        'A string, possibly empty, or a reference to a valid string. If empty, text will be simply concatenated.',
    },
    {
      name: 'ignore_empty',
      type: ArgType.boolean,
      description:
        "A boolean; if TRUE, empty cells selected in the text arguments won't be included in the result.",
    },
    {
      name: 'text',
      type: ArgType.any,
      description: 'Any text item. This could be a string, or an array of strings in a range.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional text item(s).',

  evalWithTypedValues: (
    delimitersTypedValue: TypedValue,
    ignoreEmpty: BooleanTypedValue,
    ...textTypedValues
  ): TypedValue => {
    const delimiters = getFlattenedStringValues(delimitersTypedValue);
    let texts: Array<string> = textTypedValues.flatMap((typedValue: TypedValue) =>
      getFlattenedStringValues(typedValue)
    );
    if (ignoreEmpty.booleanValue) {
      texts = texts.filter((t: string) => t);
    }
    const delimitedText = texts
      .flatMap((text: string, index: number) => [
        text,
        index < texts.length - 1 ? delimiters[index % delimiters.length] : '',
      ])
      .join('');
    return {
      rawValue: delimitedText,
      type: BaseTypedValueType.STRING,
    };
  },
} satisfies TypedValueSpreadsheetFunction;
